import React, { Component } from 'react';
import { Modal, Table, Pagination, Button } from 'antd';
import { connect } from 'react-redux';
import Mixpanel from 'mixpanel-browser';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import { columns } from './columns';
import { isEmpty } from '../../../utilities/util';
import { paymentPlansEffects } from '../../../@betterhalf-private/redux/src';

class PaymentsHistoryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
  }

  componentDidMount() {
    const { fetchPaymentsHistory, userId: id } = this.props;
    fetchPaymentsHistory({ id, url: null });
  }

  handleOkPress = () => {
    const { onModalClose } = this.props;
    this.setState({
      currentPage: 1,
    });
    onModalClose();
  };

  onChangePage = (page) => {
    this.setState({
      currentPage: page,
    });
  };

  itemRender = (current, type, originalElement) => {
    const { paymentsHistory, userId: id, fetchPaymentsHistory } = this.props;
    const { isLoading } = paymentsHistory;
    const { next, previous } = paymentsHistory.data;
    if (type === 'prev') {
      return (
        <Button
          disabled={isEmpty(previous) || isLoading}
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 10,
          }}
          onClick={
            isEmpty(previous)
              ? () => {}
              : () => {
                  Mixpanel.track('SHOW_RECOMMENDATIONS_PREVIOUS');
                  fetchPaymentsHistory({ id, url: previous });
                }
          }
        >
          <LeftOutlined />
        </Button>
      );
    }

    if (type === 'next') {
      return (
        <Button
          disabled={isEmpty(next) || isLoading}
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 10,
          }}
          onClick={
            isEmpty(next)
              ? () => {}
              : () => {
                  Mixpanel.track('SHOW_RECOMMENDATIONS_NEXT');
                  fetchPaymentsHistory({ id, url: next });
                }
          }
        >
          <RightOutlined />
        </Button>
      );
    }

    return originalElement;
  };

  render() {
    const { title, onModalClose, visible, paymentsHistory } = this.props;
    const { isLoading, data } = paymentsHistory;
    const { currentPage } = this.state;

    return (
      <Modal
        visible={visible}
        title={title}
        destroyOnClose
        width="90%"
        onCancel={() => {
          this.setState({ currentPage: 1 });
          onModalClose();
        }}
        onOk={() => this.handleOkPress()}
      >
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={isEmpty(data) ? [] : data.results}
          rowKey={(row) => row.id}
          scroll={{ x: true }}
          pagination={false}
        />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 30,
          }}
        >
          <Pagination
            hideOnSinglePage
            simple
            current={currentPage}
            total={data.count}
            onChange={this.onChangePage}
            itemRender={this.itemRender}
          />
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  paymentsHistory: state.paymentsHistory,
});

export default connect(mapStateToProps, {
  fetchPaymentsHistory: paymentPlansEffects.fetchPaymentsHistory,
})(PaymentsHistoryModal);
